
import i18n from '@/i18n';export const INTERNET_JOBS = [
  // 一、技术研发类（核心）
  { value: i18n.t('前端开发工程师'), label: i18n.t('前端开发工程师') },
  { value: i18n.t('后端开发工程师'), label: i18n.t('后端开发工程师') },
  { value: i18n.t('全栈开发工程师'), label: i18n.t('全栈开发工程师') },
  { value: i18n.t('iOS开发工程师'), label: i18n.t('iOS开发工程师') },
  { value: i18n.t('Android开发工程师'), label: i18n.t('Android开发工程师') },
  { value: i18n.t('Flutter开发工程师'), label: i18n.t('Flutter开发工程师') },
  { value: i18n.t('小程序开发工程师'), label: i18n.t('小程序开发工程师') },
  { value: i18n.t('Web开发工程师'), label: i18n.t('Web开发工程师') },
  { value: i18n.t('游戏开发工程师'), label: i18n.t('游戏开发工程师') },

  // 二、算法/数据类
  { value: i18n.t('算法工程师'), label: i18n.t('算法工程师') },
  { value: i18n.t('数据工程师'), label: i18n.t('数据工程师') },
  { value: i18n.t('数据分析师'), label: i18n.t('数据分析师') },
  { value: i18n.t('机器学习工程师'), label: i18n.t('机器学习工程师') },
  { value: i18n.t('AI工程师'), label: i18n.t('AI工程师') },
  { value: i18n.t('大数据工程师'), label: i18n.t('大数据工程师') },
  { value: i18n.t('BI分析师'), label: i18n.t('BI分析师') },

  // 三、测试/质量保障类
  { value: i18n.t('测试工程师'), label: i18n.t('测试工程师') },
  { value: i18n.t('自动化测试工程师'), label: i18n.t('自动化测试工程师') },
  { value: i18n.t('性能测试工程师'), label: i18n.t('性能测试工程师') },
  { value: i18n.t('安全测试工程师'), label: i18n.t('安全测试工程师') },
  { value: i18n.t('QA工程师（质量保障）'), label: i18n.t('QA工程师（质量保障）') },

  // 四、运维/基础设施类
  { value: i18n.t('DevOps工程师'), label: i18n.t('DevOps工程师') },
  { value: i18n.t('运维工程师'), label: i18n.t('运维工程师') },
  { value: i18n.t('云运维工程师'), label: i18n.t('云运维工程师') },
  { value: i18n.t('网络工程师'), label: i18n.t('网络工程师') },
  { value: i18n.t('安全工程师'), label: i18n.t('安全工程师') },

  // 五、产品类
  { value: i18n.t('产品经理'), label: i18n.t('产品经理') },
  { value: i18n.t('产品助理'), label: i18n.t('产品助理') },
  { value: i18n.t('产品设计经理'), label: i18n.t('产品设计经理') },
  { value: i18n.t('增长产品经理'), label: i18n.t('增长产品经理') },
  { value: i18n.t('商业产品经理'), label: i18n.t('商业产品经理') },
  { value: i18n.t('数据产品经理'), label: i18n.t('数据产品经理') },
  { value: i18n.t('UX产品经理'), label: i18n.t('UX产品经理') },

  // 六、设计类
  { value: i18n.t('UI设计师'), label: i18n.t('UI设计师') },
  { value: i18n.t('UX设计师（用户体验）'), label: i18n.t('UX设计师（用户体验）') },
  { value: i18n.t('交互设计师'), label: i18n.t('交互设计师') },
  { value: i18n.t('视觉设计师'), label: i18n.t('视觉设计师') },
  { value: i18n.t('动效设计师'), label: i18n.t('动效设计师') },
  { value: i18n.t('图标设计师'), label: i18n.t('图标设计师') },
  { value: i18n.t('品牌设计师'), label: i18n.t('品牌设计师') },
  { value: i18n.t('UI开发工程师（切图/还原）'), label: i18n.t('UI开发工程师（切图/还原）') },

  // 七、运营类
  { value: i18n.t('运营经理'), label: i18n.t('运营经理') },
  { value: i18n.t('内容运营'), label: i18n.t('内容运营') },
  { value: i18n.t('用户运营'), label: i18n.t('用户运营') },
  { value: i18n.t('活动运营'), label: i18n.t('活动运营') },
  { value: i18n.t('社群运营'), label: i18n.t('社群运营') },
  { value: i18n.t('产品运营'), label: i18n.t('产品运营') },

  // 八、市场/品牌类
  { value: i18n.t('市场经理'), label: i18n.t('市场经理') },
  { value: i18n.t('品牌经理'), label: i18n.t('品牌经理') },
  { value: i18n.t('数字营销专员'), label: i18n.t('数字营销专员') },
  { value: i18n.t('SEO专员'), label: i18n.t('SEO专员') },
  { value: i18n.t('SEM专员'), label: i18n.t('SEM专员') },
  { value: i18n.t('新媒体运营'), label: i18n.t('新媒体运营') },
  { value: i18n.t('公关专员'), label: i18n.t('公关专员') },
  { value: i18n.t('广告投放专员'), label: i18n.t('广告投放专员') },

  // 九、销售/商务类
  { value: i18n.t('销售经理'), label: i18n.t('销售经理') },
  { value: i18n.t('客户成功经理'), label: i18n.t('客户成功经理') },
  { value: i18n.t('商务拓展（BD）'), label: i18n.t('商务拓展（BD）') },
  { value: i18n.t('渠道经理'), label: i18n.t('渠道经理') },
  { value: i18n.t('售前工程师'), label: i18n.t('售前工程师') },
  { value: i18n.t('售后工程师'), label: i18n.t('售后工程师') },

  // 十、职能支持类
  { value: i18n.t('人力资源专员'), label: i18n.t('人力资源专员') },
  { value: i18n.t('人力资源经理'), label: i18n.t('人力资源经理') },
  { value: i18n.t('招聘专员'), label: i18n.t('招聘专员') },
  { value: i18n.t('行政专员'), label: i18n.t('行政专员') },
  { value: i18n.t('财务专员'), label: i18n.t('财务专员') },
  { value: i18n.t('法务专员'), label: i18n.t('法务专员') },
  { value: i18n.t('项目经理（PM）'), label: i18n.t('项目经理（PM）') },
  { value: i18n.t('办公室主任'), label: i18n.t('办公室主任') },
];
